import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import AuthContext from '../context/AuthContext'

import Dashboard from '../assets/images/sidebar_icon1.svg'
import User from '../assets/images/sidebar_icon2.svg'
import Logout from '../assets/images/sidebar_icon11.svg'
import BlogManagerIcon from '../assets/images/Blog Manager.svg'
import UserVerificationManagerIcon from '../assets/images/User_verification.svg'
import RequestManagerIcon from '../assets/images/request_manager.svg'
import ConsultationManagerIcon from '../assets/images/consulation_manager.svg'
import StaticContentIcon from '../assets/images/Static_Content.svg'
import CategorySubCategoryIcon from '../assets/images/Category_subcategry.svg'
import HelpAndSupportIcon from '../assets/images/help_support.svg'
import LocationManagerIcon from '../assets/images/location manager.svg'
import NotificationManagerIcon from '../assets/images/notification Manager.svg'
import ReasonReportManagerIcon from '../assets/images/reson report.svg'
import BackgroundManagerIcon from '../assets/images/background_manager.svg'
import ServiceManagerIcon from '../assets/images/services_manager.svg'
import TutorialManagerIcon from '../assets/images/Tutorial_manager.svg'

import { useTranslation } from 'react-i18next'
import Modal from "react-modal";
import LogoutModal from "./LogoutModal";
const classNames = require('classnames')

const Sidebar = () => {
  const { t } = useTranslation()
  const {
    logoutUser,
    user,
    sidebarStatus,
    handleSidebar,
    updatePageName
  } = useContext(AuthContext)

  const [isStaticPagePermission, setIsStaticPagePermission] = useState(false)
  const [showLogoutModal, setShowLogoutModal] = useState(false); // <-- add state

  const handleLogout = () => {
    setShowLogoutModal(true); // <-- open modal instead of window.confirm
  }

  const confirmLogout = () => {
    setShowLogoutModal(false);
    logoutUser();
  }

  const cancelLogout = () => {
    setShowLogoutModal(false);
  }

  const checkSidebarPermission = arg => {
    if (!user) {
      return false
    }
    const localPermissions = [...user?.permission]
    if (localPermissions.length === 0) {
      return true
    }
    const perIndex = localPermissions.findIndex(item => item?.manager === arg)
    if (perIndex < 0) {
      return false
    }
    return localPermissions[perIndex]?.view
  }

  const handleCheckPermission = checkPermissions => {
    return checkPermissions.some(perm => checkSidebarPermission(perm))
  }

  useEffect(() => {
    const staticPages = ['about_us', 'contact_us', 'faqs', 'privacy_policy', 'terms_and_conditions']
    setIsStaticPagePermission(handleCheckPermission(staticPages))
  }, [])

  if (!user) {
    return <></>
  }

  return (
    <>
      <div
        className={`sidebar lg:block z-10 ${
          sidebarStatus === "open" ? "block" : "hidden"
        } bg-zinc-900 w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
        onClick={handleSidebar}
      >
        <div className="text-white ">
          <Link
            to="/dashboard"
            onClick={() => updatePageName("Dashboard")}
            className="px-2 py-6 w-full text-center flex justify-center"
          >
            <img src="/images/white_logo.svg" className="inline" alt="logo" />
          </Link>
          <div className="profile text-center">
            <small className="block text-sm">Welcome</small>
            <strong className="block text-lg overflow-hidden text-ellipsis px-2 whitespace-nowrap">{`${user?.firstName} ${user?.lastName}`}</strong>
          </div>

          <nav className="pt-4 pb-5 flex flex-col justify-center font-normal text-[15px] overflow-y-auto">
            {checkSidebarPermission("dashboard") && (
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_DASHBOARD"))}
              >
                <span className="mr-2">
                  <img src={Dashboard} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_DASHBOARD")}
              </NavLink>
            )}
            {checkSidebarPermission("customers") && (
              <NavLink
                to="/users"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("O_USERS"))}
              >
                <span className="mr-2">
                  <img src={User} className="max-w-[18px]" alt="" />
                </span>
                {t("O_USERS")}
              </NavLink>
            )}
            {checkSidebarPermission("category") && (
              <NavLink
                to="/category"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("O_CATEGORY_MANAGE"))}
              >
                <span className="mr-2">
                  <img
                    src={CategorySubCategoryIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_CATEGORY_SUB_CATEGORY_MANAGER")}
              </NavLink>
            )}
          
            {checkSidebarPermission("area") && (
              <NavLink
                to="/area"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("AREA_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={CategorySubCategoryIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {"Area Manager"}
              </NavLink>
            )}

            {checkSidebarPermission("product") && (
              <NavLink
                to="/product"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName("Manage Product")}
              >
                <span className="mr-2">
                  <img
                    src={CategorySubCategoryIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("PRODUCT_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("price") && (
              <NavLink
                to="/price"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName("Manage Price")}
              >
                <span className="mr-2">
                  <img
                    src={CategorySubCategoryIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {"Price Manager"}
              </NavLink>
            )}
            {checkSidebarPermission("locations") && (
              <NavLink
                to="/locations"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("O_DISTRICTS"))}
              >
                <span className="mr-2">
                  <img
                    src={LocationManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("O_NAV_LOCATION_MANAGE")}
              </NavLink>
            )}
            {checkSidebarPermission("reason_report") && (
              <NavLink
                to="/reason-report"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("O_REASON_REPORTS"))}
              >
                <span className="mr-2">
                  <img
                    src={ReasonReportManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_REASON_REPORTS_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("help_and_support") && (
              <NavLink
                to="/help-and-support"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("O_HELP_AND_SUPPORT"))}
              >
                <span className="mr-2">
                  <img
                    src={HelpAndSupportIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("O_HELP_AND_SUPPORT")}
              </NavLink>
            )}
            {checkSidebarPermission("notification_managers") && (
              <NavLink
                to="/notifications"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_NOTIFICATION_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={NotificationManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_NOTIFICATION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("blog_manager") && (
              <NavLink
                to="/blogs"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_BLOG_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={BlogManagerIcon} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_BLOG_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("tutorial_manager") && (
              <NavLink
                to="/tutorials"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_TUTORIAL_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={TutorialManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_TUTORIAL_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("service_manager") && (
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_SERVICE_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={ServiceManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_SERVICE_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("user_verification_manager") && (
              <NavLink
                to="/user-verification-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_USER_VERIFICATION_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img
                    src={UserVerificationManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_USER_VERIFICATION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("marketplace_request_manager") && (
              <NavLink
                to="/marketplace-request-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_MARKETPLACE_REQUEST_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={RequestManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_MARKETPLACE_REQUEST_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("consultation_manager") && (
              <NavLink
                to="/consultation-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_CONSULTATION_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={ConsultationManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_CONSULTATION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("background_manager") && (
              <NavLink
                to="/backgrounds"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_BACKGROUND_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={BackgroundManagerIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_BACKGROUND_MANAGER")}
              </NavLink>
            )}
            {isStaticPagePermission && checkSidebarPermission("about_us") && (
              <NavLink
                to="/static"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue",
                    { active: isActive }
                  )
                }
                onClick={() => updatePageName(t("NAV_STATIC_CONTENTS"))}
              >
                <span className="mr-2">
                  <img
                    src={StaticContentIcon}
                    className="max-w-[18px]"
                    alt=""
                  />
                </span>
                {t("NAV_STATIC_CONTENTS")}
              </NavLink>
            )}
            <div className="border-t border-white/20 my-2"></div>
            <div
              onClick={handleLogout}
              className="flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue cursor-pointer"
            >
              <span className="mr-2">
                <img src={Logout} className="max-w-[18px]" alt="" />
              </span>
              {t("NAV_LOGOUT")}
            </div>
            <LogoutModal
              isOpen={showLogoutModal}
              onCancel={cancelLogout}
              onConfirm={confirmLogout}
            />
          </nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar
